var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#ey_svg__clip0_13385_2768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 14.167c2.71 0 5.349-.005 7.988.01.184 0 .45.099.538.233.594.915 1.15 1.851 1.801 2.915H4.985v2.253h5.218v2.94h-5.22v2.38h5.665c1.115 0 1.673.527 1.673 1.58V28H.5V14.167zM10.417 14.09c1.506 0 2.973-.02 4.437.025.206.006.464.306.591.525.738 1.283 1.444 2.582 2.217 3.978.764-1.377 1.494-2.637 2.161-3.926.24-.462.524-.634 1.064-.62 1.328.035 2.657.011 4.143.011-.206.364-.333.607-.477.84-1.422 2.312-2.863 4.613-4.256 6.94-.24.4-.38.906-.395 1.367-.048 1.537-.018 3.075-.018 4.655h-4.442c0-.695-.074-1.412.014-2.111.286-2.278-.378-4.255-1.742-6.142-1.209-1.672-2.186-3.494-3.262-5.251-.024-.039-.013-.097-.034-.29h-.001zM.5 9.891L29.5 0v5.1L.5 9.89z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ey_svg__clip0_13385_2768"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h29v28H0z"
  })))));
}
export default SvgEy;